import React from "react"
import classnames from "classnames"
import styles from "./OutletStoreEnquiryForm.less"
import gtmHandler from "AtomicUtils/gtmHandler"
import {
  InputText,
  Space,
  InputCheckBox,
  A,
  Button,
  InputSelect,
  P,
  H3,
  H5,
  H6,
  Section,
  FormGroup,
  InputEmail,
  InputRadio,
  StarIcon,
  Interactive
} from "AtomicComponents"
import { AlertList, Disclaimer } from "AtomicContainers"
import fetchAPI from "AtomicUtils/fetchAPI"
import { fromLinkInputs, formLinkSubmit } from "AtomicUtils/formHandler"
import { IS_MOBILE } from "AtomicUtils/environment"
import componentParser from "AtomicUtils/componentParser"
import MESSAGES from "AtomicConstants/MESSAGES"
import TITLES from "./TITLES"

class OutletStoreEnquiryForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      form: {
        title: {
          validations: {
            required: MESSAGES.TITLE_REQUIRED
          }
        },
        firstName: {
          validations: {
            required: MESSAGES.FIRSTNAME_REQUIRED
          }
        },
        lastName: {
          validations: {
            required: MESSAGES.LASTNAME_REQUIRED
          }
        },
        phone: {
          validations: {
            required: MESSAGES.PHONE_NUMBER_REQUIRED,
            phone: MESSAGES.PHONE_NUMBER_INVALID
          }
        },
        comments: {
          validations: {
          }
        },
        finance: {
          validations: {
          }
        },
        optedInDealer: {
          validations: {
            required: MESSAGES.OPTIN_REQUIRED
          }
        },
        email: {
          validations: {
            required: MESSAGES.EMAIL_REQUIRED,
            email: MESSAGES.EMAIL_INVALID
          }
        },
        privacy: {
          validations: {
            required: MESSAGES.PRIVACY_POLICY_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null,
    }
  }

  _handleSubmit = async (event) => {
    const { financeOptionText, buttonText = "Submit" } = this.props
    if (event) event.preventDefault()
    const { loading, form } = this.state
    if (!loading && !form.submitButton.disabled) {
      await this.setState({
        loading: true
      }, async () => {
        const { stockData, dealer, prospectApiSource = "Web_OutletStore", prospectApiProperty = "communicationPermissions", prospectApiPropertyValue = "Mazda_Dealer_Opt_In", submitFormEndPoint } = this.props
        const { form } = this.state
        let body = {
          email: form.email.value,
          comments: form.comments.value || null,
          firstName: form.firstName.value,
          lastName: form.lastName.value,
          phone: form.phone.value,
          title: form.title.value,
          financeInterest: financeOptionText ? (form.finance.value === true ? 'Yes' : null) : undefined,
          nameplate: stockData.nameplate,
          stockNumber: stockData.stockNumber,
          dealerLocation: dealer.id,
          dealerCode: dealer.dealerCode,
          prospectApiSource,
          prospectApiProperty,
          prospectApiPropertyValue
        }

        await fetchAPI({
          method: "POST",
          url: submitFormEndPoint,
          body: body
        })
        .then(async (response) => {
          const json = await response.json()
          const { success, errorMsg } = json
          if (!success) {
            this.setState({
              errorMessage: errorMsg,
              loading: false
            })
          } else {
            // successful
            this.setState({
              loading: false,
              success: true
            }, () => {
              gtmHandler({
                pageCategory: "Outlet Store",
                pageAction: `Outlet Store Form - Clicked "${buttonText.toUpperCase()}"`
              })
            })
          }
        })
        .catch((response) => {
          this.setState({
            errorMessage: response.message || `Failed with status ${response.status}`,
            loading: false
          })
        })
      })
    }
  }

  _handleOnBlurSearchableRegion = () => {
    const { form } = this.state
    if (form && form.region && form.region.value && form.region.value.description){
      gtmHandler({
        pageCategory: "Outlet Store",
        pageAction: `Outlet Store Form - Selected "POSTCODE/SUBURB" - "${form.region.value.description.toUpperCase()}"`
      })
    }
  }


  render() {
    const {
      title,
      description,
      optInMessage,
      privacyPolicy,
      privacyPolicyLink,
      financeOptionText,
      buttonText = "Submit",
      dealer,
      stockData,
      thankYouComponents
    } = this.props
    const { loading, form, success, errorMessage } = this.state
    if (success) {
      return componentParser(thankYouComponents)
    }

    return (
      <div>
        <Section padding backgroundColor="#f5f5f5">
          <div className={classnames({
            [styles.OutletStoreEnquiryForm]: true
          })}>
            <div className={classnames({
              [styles.OutletStoreEnquiryFormForm]: true
            })}>
              <H6 withDetails>{title}</H6>
              <H3 withDetails>{`CONTACT ${dealer.name}`}</H3>
              <P>{description}</P>
            </div>
          </div>
        </Section>
        <Section horizontalPadding backgroundColor="#FFFFFF">
          <div className={classnames({
            [styles.OutletStoreEnquiryFormDealer]: true
          })}>
            <FormGroup>
              <Space />
              <Space />
              <Interactive>Dealer</Interactive>
              <P withoutMargin>{dealer.name}</P>
              <Space />
              <Interactive>Model</Interactive>
              <P withoutMargin>{`${stockData.nameplate} ${stockData.bodyStyle} ${stockData.grade}`}</P>
              <Space />
              <div className={classnames({
                [styles.OutletStoreEnquiryFormDealerPrice]: true
              })}>
                <H6 withDetails>Delivered price in {dealer.state}</H6>
                <A
                  withoutStyle
                  onClick={(event) => {
                    if (event && event.target && event.target.querySelector('button')){
                      event.target.querySelector('button').click()
                    }
                  }}
                >
                  <H3 withDetails>
                    ${stockData.price.toLocaleString()}
                    <Disclaimer Icon={StarIcon}>
                      {stockData.disclaimer}
                    </Disclaimer>
                  </H3>
                </A>
              </div>
              {
                IS_MOBILE &&
                <div className={classnames({
                  [styles.OutletStoreEnquiryFormDealerMobile]: true
                })}>
                  <Space />
                  <Space />
                  <Button href={`tel:${dealer.departments[0].phone}`} fullWidth>Call dealer</Button>
                  <P>Or fill the form below and your dealer will contact you directly.</P>
                </div>
              }
            </FormGroup>
          </div>
        </Section>
        <Section horizontalPadding backgroundColor="#f5f5f5">
          <div className={classnames({
            [styles.OutletStoreEnquiryForm]: true
          })}>
            <div className={classnames({
              [styles.OutletStoreEnquiryFormForm]: true
            })}>
              <form method="POST" onSubmit={this._handleSubmit} noValidate>
                <FormGroup center>
                  <H5>
                    Enter your details
                  </H5>
                </FormGroup>

                <FormGroup>
                  <InputSelect
                    name="title"
                    label="Title"
                    options={TITLES}
                    {...fromLinkInputs(this, "title")}
                    onBlur={()=>{
                      if (form.title.value) {
                        gtmHandler({
                          pageCategory: "Outlet Store",
                          pageAction: `Outlet Store Form - Selected "TITLE" - "${form.title.value.toUpperCase()}"`
                        })
                      }
                    }}
                  />
                </FormGroup>

                <FormGroup>
                  <InputText
                    name="firstName"
                    label="First Name"
                    {...fromLinkInputs(this, "firstName")}
                    onBlur={()=>{
                      gtmHandler({
                        pageCategory: "Outlet Store",
                        pageAction: "Outlet store enquiry Form - Entered \"FIRSTNAME\""
                      })
                    }}
                  />
                </FormGroup>
                <FormGroup>
                  <InputText
                    name="lastName"
                    label="Last Name"
                    {...fromLinkInputs(this, "lastName")}
                    onBlur={()=>{
                      gtmHandler({
                        pageCategory: "Outlet Store",
                        pageAction: "Outlet store enquiry Form - Entered \"LASTNAME\""
                      })
                    }}
                  />
                </FormGroup>
                <FormGroup>
                  <InputText
                    name="phone"
                    label="Phone"
                    {...fromLinkInputs(this, "phone")}
                    onBlur={()=>{
                      gtmHandler({
                        pageCategory: "Outlet Store",
                        pageAction: "Outlet store enquiry Form - Entered \"PHONE\""
                      })
                    }}
                  />
                </FormGroup>
                <FormGroup>
                  <InputEmail
                    name="email"
                    label="Email"
                    {...fromLinkInputs(this, "email")}
                    onBlur={()=>{
                      gtmHandler({
                        pageCategory: "Outlet Store",
                        pageAction: "Outlet store enquiry Form - Entered \"EMAIL\""
                      })
                    }}
                  />
                </FormGroup>

                <FormGroup>
                  <InputText
                    name="comments"
                    label="Questions / Comments"
                    {...fromLinkInputs(this, "comments")}
                    onBlur={()=>{
                      gtmHandler({
                        pageCategory: "Outlet Store",
                        pageAction: "Outlet store enquiry Form - Entered \"ENQUIRY\""
                      })
                    }}
                  />
                </FormGroup>
                {
                  financeOptionText &&
                  <FormGroup show checkbox>
                    <InputCheckBox
                      name="finance"
                      label={financeOptionText}
                      {...fromLinkInputs(this, "finance", (value) => {
                        gtmHandler({
                          pageCategory: "Outlet store",
                          pageAction: `Outlet store enquiry Form - ${value ? 'Checked' : 'Unchecked'} \"FINANCE\"`
                        })
                      })}
                    />
                  </FormGroup>
                }
                {
                  financeOptionText &&
                  <FormGroup show checkbox>
                    <hr style={{ height: "1px", width: "100%", border: "0", borderTop: "1px solid #D5D5D5" }} />
                  </FormGroup>
                }
                {!financeOptionText && <Space />}
                <FormGroup show checkbox>
                  <InputCheckBox
                    name="optedInDealer"
                    label={optInMessage || "I acknowledge that Mazda or Mazda dealers may send me further information about Mazda products or services."}
                    {...fromLinkInputs(this, "optedInDealer", (value) => {
                      gtmHandler({
                        pageCategory: "Outlet store",
                        pageAction: `Outlet store enquiry Form - ${value ? 'Checked' : 'Unchecked'} \"OPT IN\"`
                      })
                    })}
                  />
                </FormGroup>
                <Space />
                <FormGroup show checkbox>
                  <InputCheckBox
                    name="privacy"
                    label={
                      <span>
                        {privacyPolicy}{" "}
                        <A
                          href={privacyPolicyLink}
                          onClick={() => {
                            gtmHandler({
                              pageCategory: "Outlet Store",
                              pageAction: "Outlet store enquiry Form - Clicked \"PRIVACYPOLICY\""
                            })
                          }}
                          external>
                            <nobr>Privacy Policy</nobr>
                        </A>
                      </span>
                    }
                    {...fromLinkInputs(this, "privacy", (value) => {
                      gtmHandler({
                        pageCategory: "Outlet Store",
                        pageAction: `Outlet store enquiry Form - ${value ? 'Checked' : 'Unchecked'} \"PRIVACYPOLICY\"`
                      })
                    })}
                  />
                </FormGroup>
                <Space />
                <Space />
                <FormGroup>
                  {errorMessage &&
                    <AlertList data={errorMessage} />
                  }
                  <Button
                    styleName="black"
                    loading={loading}
                    fullWidth
                    {...formLinkSubmit(this, this._handleSubmit)}
                  >
                    {buttonText}
                  </Button>
                </FormGroup>

              </form>
            </div>
          </div>
        </Section>
      </div>
    )
  }
}


export default OutletStoreEnquiryForm



// WEBPACK FOOTER //
// ./src/AtomicContainers/OutletStoreEnquiryForm/OutletStoreEnquiryForm.jsx